import React, { FC } from 'react';
import { Switcher } from 'components/atoms/switcher';
import { useTranslate } from 'hooks/use-translation';
import { NewUpdateButton } from '../new-update-btn';
import { Tabs, Wrapper, SwitcherButton } from './styles';
import { FilteredUpdates } from '.';

export enum StatusUpdateFilters {
  All = 'all',
  Sent = 'sent',
  Drafts = 'drafts',
}

interface StatusUpdateFilterTabProps {
  filteredTabData: FilteredUpdates;
  tab: StatusUpdateFilters;
  onChange: (tab: StatusUpdateFilters) => void;
}

export const StatusUpdateFilterTabs: FC<StatusUpdateFilterTabProps> = ({
  filteredTabData,
  tab,
  onChange,
}) => {
  const translate = useTranslate();
  const handleTabChange = ({ key }) => {
    onChange(key);
  };

  return (
    <Wrapper>
      <Tabs selectedKeys={[tab]} mode="horizontal">
        <Switcher
          value={tab}
          onChange={(e) => handleTabChange({ key: e.target.value })}
          activeColor="black"
        >
          <SwitcherButton
            value={StatusUpdateFilters.All}
            data-cy={`project-updates.switcher.${StatusUpdateFilters.All}`}
          >
            {`${translate('all')} (${
              filteredTabData[StatusUpdateFilters.All].length
            })`}
          </SwitcherButton>
          <SwitcherButton
            value={StatusUpdateFilters.Sent}
            data-cy={`project-updates.switcher.${StatusUpdateFilters.Sent}`}
          >
            {`${translate('sent')} (${
              filteredTabData[StatusUpdateFilters.Sent].length
            })`}
          </SwitcherButton>
          <SwitcherButton
            value={StatusUpdateFilters.Drafts}
            data-cy={`project-updates.switcher.${StatusUpdateFilters.Drafts}`}
          >
            {`${translate('draft')} (${
              filteredTabData[StatusUpdateFilters.Drafts].length
            })`}
          </SwitcherButton>
        </Switcher>
      </Tabs>
      <NewUpdateButton />
    </Wrapper>
  );
};
